import { createContext } from 'react';

import { defaultLegend } from '../constants/defaults.js';
import { HistogramChartLegendConfig } from '../types/histogram-props.js';

export const HistogramLegendContext =
  createContext<HistogramChartLegendConfig>(defaultLegend);
